import React, { ReactElement } from 'react'

interface Props {}

const Hello = ({}: Props): ReactElement => {
  return <div>view from Common packages!!!</div>
}
export default Hello